import { createSelector } from '@reduxjs/toolkit';

import { getLayoutModels } from '@paragon/layout-models';
import { getLoggedInUser } from '@paragon/login-tools';

import { RootState } from '..';
import { JobLayoutModel } from '../actions/loadActions';

/**
 * Returns the layout model of the current job, if and only if the design client is in a job context.
 */
export const getActiveJobLayoutModel = createSelector(
  getLayoutModels,
  (state: RootState) => state.application.openContext,

  (layoutModels, openContext): JobLayoutModel | null => {
    if (openContext?.type === 'job') {
      return layoutModels.find((model) => model.guid === openContext.jobId.toString()) as JobLayoutModel;
    }

    return null;
  },
);

export const isParagonJobOpen = createSelector(
  getActiveJobLayoutModel,

  (jobLayoutModel) => jobLayoutModel && jobLayoutModel.isParagonJob,
);

export const isParagonRepairJobOpen = createSelector(
  getActiveJobLayoutModel,
  isParagonJobOpen,

  (jobLayoutModel, isParagonJobOpen) => !!jobLayoutModel && !!isParagonJobOpen && jobLayoutModel.jobType === 'Repair',
);

/**
 * "Other organization can change inventory set for repair jobs but not seal jobs." - The Spec.
 */
export const isBlockedFromChangingMaterialSelectionBasedOnJobPermissions = createSelector(
  getLoggedInUser,
  getActiveJobLayoutModel,

  (user, activeJob) => {
    if (!user || !activeJob) {
      return false;
    }

    return user.organization !== activeJob.ownerOrganization && activeJob.jobType !== 'Repair';
  },
);
